import React from "react";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList
} from 'recharts';
import { tooltipStyle } from "../../../helpers/Executive-Dashboard/styleFormat";
import { fmtNum, fmt } from "../../../helpers/Executive-Dashboard/formatters";

export const TopBarChart = React.memo(({ data, color }) => {
    if (!data || data.length === 0) {
        return <div style={{ color: '#94a3b8', fontSize: '12px', textAlign: 'center', padding: '40px 0' }}>Belum ada data</div>;
    }
    // Build shortNames and ensure uniqueness to prevent tooltip/label mismatch
    const nameCount = {};
    const chartData = data.map(d => {
        let short = d.name && d.name.length > 18 ? d.name.substring(0, 17) + '…' : (d.name || 'N/A');
        nameCount[short] = (nameCount[short] || 0) + 1;
        if (nameCount[short] > 1) short = `${short} (${nameCount[short]})`;
        return { ...d, shortName: short };
    });
    const labelFmt = (v) => {
        if (v == null || isNaN(v)) return '0';
        const abs = Math.abs(v);
        if (abs >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1).replace('.0', '')} M`;
        if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace('.0', '')} jt`;
        if (abs >= 1_000) return `${(v / 1_000).toFixed(0)} rb`;
        return `${v}`;
    };
    return (
        <div style={{ height: '280px' }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} layout="vertical" barSize={16} margin={{ top: 10, right: 60, bottom: 10, left: 0 }}>
                    <XAxis type="number" hide />
                    <YAxis 
                        dataKey="shortName" 
                        type="category" 
                        width={123} 
                        tick={({ y, payload }) => (
                            <text x={0} y={y} dy={4} textAnchor="start" fill="#64748b" fontSize={10}>
                                {payload.value}
                            </text>
                        )} 
                        interval={0} 
                    />
                    <Tooltip content={({ active, payload }) => {
                        if (!active || !payload || !payload.length) return null;
                        const d = payload[0].payload;
                        return (
                            <div style={{ ...tooltipStyle, padding: '10px 14px' }}>
                                <div style={{ fontWeight: 600, marginBottom: '6px', color: '#334155' }}>{d.name}</div>
                                {d.invoiceCount != null && (
                                    <div style={{ color: '#64748b', fontSize: '11px' }}>Jumlah Invoice: {fmtNum(d.invoiceCount)}</div>
                                )}
                                {d.qty != null && (
                                    <>
                                        <div style={{ color: '#64748b', fontSize: '11px' }}>Qty: {fmtNum(d.qty)}</div>
                                        <div style={{ color: '#64748b', fontSize: '11px' }}>Kode Barang: {d.kodeBarang}</div>
                                        <div style={{ color: '#64748b', fontSize: '11px' }}>Satuan: {d.itemUnit ? (d.itemUnit).toUpperCase() : ''}</div>
                                    </>
                                )}
                                <div style={{ color: color, fontWeight: 600, marginTop: '4px' }}>Total: {fmt(d.total)}</div>
                            </div>
                        );
                    }} />
                    <Bar dataKey="total" fill={color} radius={[0, 6, 6, 0]} name="Total">
                        <LabelList dataKey="total" position="right" formatter={labelFmt} style={{ fill: '#64748b', fontSize: 10, fontWeight: 600 }} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
});